<template>

  <!-- Packages Start -->
  <div class="section section-padding mt-n10 package-page-padding">
    <div class="container">

      <!-- Section Title Start -->
      <div class="section-title shape-03 text-center">
        <h2 class="main-title">Choose your right Package for your Maritime <span>Success!</span></h2>
      </div>
      <!-- Section Title End -->

      <div class="row gx-10">
        <!-- Basic Package -->
        <div class="col-lg-3 padding-right-0">
          <div class="sidebar">
            <div class="sidebar-widget widget-information">
              <div class="info-price">
                <span class="price">Basic</span>
                <span class="package-price">£20</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>10</span></li>
                  <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>2</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <button 
                  class="btn btn-primary btn-hover-dark" 
                  @click="handlePurchaseClick('Basic')">
                  Purchase Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Intermediate Package -->
        <div class="col-lg-3 padding-right-0">
          <div class="sidebar">
            <div class="sidebar-widget widget-information">
              <div class="info-price">
                <span class="price">Intermediate</span>
                <span class="package-price">£50</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>15</span></li>
                  <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>5</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <button 
                  class="btn btn-primary btn-hover-dark" 
                  @click="handlePurchaseClick('Intermediate')">
                  Purchase Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Advance Package -->
        <div class="col-lg-3 padding-right-0">
          <div class="sidebar">
            <div class="sidebar-widget widget-information">
              <div class="info-price">
                <span class="price">Advance</span>
                <span class="package-price">£100</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>20</span></li>
                  <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>10</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <button 
                  class="btn btn-primary btn-hover-dark" 
                  @click="handlePurchaseClick('Advance')">
                  Purchase Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Organisation / Customized Package (NO CHANGES) -->
        <div class="col-lg-3 padding-right-0">
          <div class="sidebar">
            <div class="sidebar-widget widget-information border-color-blue">
              <div class="info-price">
                <span class="price color-blue">Organisation / <br/>Customized</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt color-blue"></i> <strong>Questions</strong> <span>On Demand</span></li>
                  <li><i class="icofont-book color-blue" ></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time color-blue"></i> <strong style="font-size: 13px;">Final Test Attempts</strong> <span style="font-size: 15px;">On Demand</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <router-link to="/retention-package" class="btn btn-primary btn-hover-dark background-color-blue">Purchase Now</router-link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Packages End -->

  <!-- Login Required Modal -->
  <div v-if="showLoginModal" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="register-login-form login-box">
        <button class="modal-close" @click="closeModal">&times;</button>
        <h3 class="title">Login <span>Required</span></h3>
        <p class="modal-message">Please login to purchase a package</p>
        <div class="form-wrapper">
          <div class="single-form">
            <button 
              class="btn btn-primary btn-hover-dark w-100" 
              @click="goToLogin">
              Login Now
            </button>
          </div>
          <div class="single-form text-center mt-3">
            <p>Don't have an account? <router-link to="/register" class="text-primary">Register here</router-link></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Already Subscribed Modal -->
  <div v-if="showSubscribedModal" class="modal-overlay" @click="closeSubscribedModal">
    <div class="modal-content" @click.stop>
      <div class="register-login-form login-box">
        <button class="modal-close" @click="closeSubscribedModal">&times;</button>
        <h3 class="title">Already <span>Subscribed</span></h3>
        <p class="modal-message">
          You are already subscribed to the <strong>{{ currentSubscription }}</strong> package.
        </p>
        <div class="form-wrapper">
          <div class="single-form">
            <button 
              class="btn btn-primary btn-hover-dark w-100" 
              @click="goToDashboard">
              Go to Dashboard
            </button>
          </div>
          <div class="single-form text-center mt-3">
            <p class="text-muted">You can manage your subscription from your dashboard</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Call to Action Start -->
  <div class="section padding-bottom-50">
    <div class="container">

      <!-- Call to Action Wrapper Start -->
      <div class="call-to-action-wrapper">

        <img class="cat-shape-01 animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">
        <img class="cat-shape-02" src="/assets/images/shape/shape-13.svg" alt="Shape">
        <img class="cat-shape-03 animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">

        <div class="row align-items-center">
          <div class="col-md-6">

            <!-- Section Title Start -->
            <div class="section-title shape-02">
              <h5 class="sub-title">Try for Free!</h5>
              <h2 class="main-title">Sign up for a free trial &amp; start your <span>MCQ prep!</span></h2>
            </div>
            <!-- Section Title End -->

          </div>
          <div class="col-md-6">
            <div class="call-to-action-btn">
              <a class="btn btn-primary btn-hover-dark" href="contact.html">Register Now</a>
            </div>
          </div>
        </div>
      </div>
      <!-- Call to Action Wrapper End -->

    </div>
  </div>
  <!-- Call to Action End -->

</template>

<script>
import { jwtDecode } from "jwt-decode";
import { request_package } from '@/services/packageService';
import { getUserPackageDetails } from '@/services/subscriptionService';
import { AppConfig } from '@/constants';

export default {
  name: 'Packages',
  data() {
    return {
      form: {},
      loader: false,
      showLoginModal: false,
      showSubscribedModal: false,
      selectedPackageId: null,
      selectedPackageName: null,
      currentSubscription: null,
      userPackage: null,
      userId: null,
      packageMap: {
        // Hardcoded package IDs - Update with your actual MongoDB IDs
        'Basic': '67d19c6b94cc76304356593c',
        'Intermediate': '67d19ccf94cc76304356593e',
        'Advance': '686cefd2fc9f902a85c42c39'
      }
    }
  },

  async mounted() {
    // Check if user is logged in and get their subscription
    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        this.userId = decoded.id;
        await this.checkUserSubscription();
      } catch (error) {
        console.error('Error checking user subscription:', error);
      }
    }
  },

  methods: {
    async checkUserSubscription() {
      try {
        const response = await getUserPackageDetails(this.userId);
        this.userPackage = response.data;
        console.log('User package:', this.userPackage);
      } catch (error) {
        console.error('Error fetching user package:', error);
        this.userPackage = null;
      }
    },

    async handlePurchaseClick(packageName) {
      const packageId = this.packageMap[packageName];
      
      if (!packageId) {
        console.error('Package ID not found for:', packageName);
        alert('Package not available. Please try again later.');
        return;
      }

      console.log('Purchase clicked for package:', packageName, 'ID:', packageId);
      
      const token = localStorage.getItem('access_token');
      
      if (!token) {
        // User not logged in - show login modal
        this.selectedPackageId = packageId;
        this.selectedPackageName = packageName;
        this.showLoginModal = true;
        return;
      }

      // User is logged in - check if they already have a subscription
      if (this.userPackage && this.userPackage.pkg_subscribed) {
        // User already has a subscription
        this.currentSubscription = this.userPackage.pkg_subscribed;
        this.showSubscribedModal = true;
        return;
      }

      // User is logged in and has no subscription - go to checkout
      this.$router.push(`/checkout/${packageId}`);
    },

    goToLogin() {
      // Store package ID in localStorage so user can continue after login
      if (this.selectedPackageId) {
        localStorage.setItem('pending_package_purchase', this.selectedPackageId);
      }
      this.$router.push('/login');
    },

    goToDashboard() {
      this.$router.push('/dashboard/user/home');
    },

    closeModal() {
      this.showLoginModal = false;
      this.selectedPackageId = null;
      this.selectedPackageName = null;
    },

    closeSubscribedModal() {
      this.showSubscribedModal = false;
    },

    async request_pkg() {
      this.loader = true;
      try {
        this.form.to = AppConfig.CONTACT_US_EMAIL;
        await request_package(this.form);
        this.form = {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loader = false;
      }
    }
  }
};
</script>

<style scoped>
/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Content */
.modal-content {
  position: relative;
  background: #fff;
  padding: 40px;
  border-radius: 10px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Close Button */
.modal-close {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 30px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  transition: color 0.3s ease;
}

.modal-close:hover {
  color: #333;
}

/* Modal Message */
.modal-message {
  text-align: center;
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
}

.modal-message strong {
  color: #309255;
  font-weight: 600;
}

/* Reuse existing login box styles */
.login-box .title {
  text-align: center;
  margin-bottom: 20px;
}

.login-box .single-form {
  margin-bottom: 15px;
}

/* Loading spinner */
button .loader {
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;
}

.loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid white;
  border-right-color: #309255;
  animation: l2 1s infinite linear;
}

@keyframes l2 {
  to {
    transform: rotate(1turn);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .modal-content {
    padding: 30px 20px;
  }
}
</style>